import {
  createObjectValidator,
  validateNumber,
  validateString,
  validateUuidV4
} from "../../../packages/validator/validator.js";

/**
 * Comments stat under one post.
 */
export type PostComments = {
  /**
   * Slug of the post.
   */
  slug: string;
  /**
   * Title of the post.
   */
  title: string;
  /**
   * ID of the post entry.
   */
  postId: string;
  /**
   * Count of the comments.
   */
  commentCount: number;
  /**
   * Unix timestamp of the last comment.
   */
  lastCommentDate: number;
};

export const validatePostComments = createObjectValidator<PostComments>("PostComments", {
  slug: validateString,
  title: validateString,
  postId: validateUuidV4,
  commentCount: validateNumber,
  lastCommentDate: validateNumber
});
